import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";

const MainLayout = () => {
  // const user = useSelector(selectCurrentUser);
  // if (!user) {
  //   return <Navigate to="/login" state={{ message: "سجل دخولك اولا قبل اضافة اي منتج" }} />;
  // }
  return (
    <React.Fragment>
      <Outlet />
      <Navbar />
    </React.Fragment>
  );
};

export default MainLayout;
